import { createSelector } from '@ngrx/store'
import { RootState } from '../root.model'

const commandsState = (state: RootState) => state.commands

export const selectCommands = createSelector(commandsState, state => state)

export const selectCommandsIsLoading = createSelector(
  commandsState,
  state => state.isLoading,
)

export const selectApprovalRequestSubmitted = createSelector(
  commandsState,
  state => state.approvalRequestSubmitted,
)
